export default __webpack_public_path__ + "static/mongodb-19ed4ac0a0070b47df3d963fcaa06633.png";